import { render, staticRenderFns } from "./InputBooleanCheckbox.vue?vue&type=template&id=3a380b3e&scoped=true&"
import script from "./InputBooleanCheckbox.vue?vue&type=script&lang=ts&"
export * from "./InputBooleanCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./InputBooleanCheckbox.vue?vue&type=style&index=0&id=3a380b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a380b3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
